module.exports = __webpack_public_path__ + "img/T7S game preview 3.a328a255.webp";